import { FeatureToggle } from './enums'

export const useFeatureToggle = (featureToggle: FeatureToggle) => {
  try {
    const featureToggleMap = {
      [FeatureToggle.communitiesBanMember]: JSON.parse(
        process?.env?.FEATURE_COMMUNITIES_BAN_MEMBER as string
      ),

      [FeatureToggle.communitiesChangeCoverImage]: JSON.parse(
        process?.env?.FEATURE_COMMUNITIES_CHANGE_COVER_IMAGE as string
      ) as boolean
    }

    return Boolean(featureToggleMap[featureToggle])
  } catch {
    return false
  }
}
